<template>
    <div 
        v-show="is_open_vertical_radar"
        id="vertical-radar-profile" 
        class="vertical-radar-profile"
        :class="{
            'vertical-radar-profile--active': is_open_vertical_radar
        }"
        @keydown.esc="toggle_vertical_radar(false)"
    >
        <div
            ref="kxd-vertical-map-container" 
            class="kxd-vertical-map-container"
            :class="{
                'kxd-vertical-map-container--active': is_open_vertical_radar
            }"
        >
            <v-card class="vertical-header">
                <img 
                    src="/static/images/tsmodal/CWA-modal-logo.png" 
                    alt="cwa logo"
                    class="vertical-dialog-title" 
                >
                <v-icon
                    v-if="path_menu_options.length"
                    color="#fff"
                    @click="is_open_path_menu = !is_open_path_menu"
                >
                    menu
                </v-icon>
                <img 
                    src="/static/images/tsmodal/close.png" 
                    @click="toggle_vertical_radar(false)"
                    class="modal-close" 
                >
            </v-card>
            <section class="map-ctrl map-right-bottom-ctrl">
                <Colorbar
                    v-if="colorbar"
                    ref="vertical-colorbar"
                    class="map-high-item vertical-colorbar"
                    :options="colorbar"
                    :draggable="true"
                />
            </section>

            <section class="map-ctrl map-bottom-ctrl">
                <div class="map-high-item vertical-timebar">
                    <QpeTimeLine 
                        v-if="timebar.list.length > 0"
                        :props_play_index.sync="timebar.default_index"
                        :list="timebar.list"
                        :duration="timebar.duration"
                        :latest_complete_data_timestamp="timebar.latest_complete_data_timestamp"
                        :auto_update_btn_activate="false"
                        @trigger-change-time="change"
                    />
                </div>
            </section>

            <section 
                v-if="path_menu_options.length"
                v-show="is_open_path_menu"
                class="path-menu"
            >  
                <div class="path-menu__block">
                    <div class="path-menu__title">
                        <span>航路</span>
                        <span
                            @click="path_selected = null"
                        >
                            清除
                        </span>
                    </div>
                    <div class="path-menu__content">    
                        <v-radio-group 
                            v-model="path_selected"
                            hide-details
                        >
                            <v-radio
                                v-for="option in path_menu_options"
                                class="data_item"
                                :key="option"
                                :label="option"
                                :value="option"
                                :ripple="false"
                            />
                        </v-radio-group>
                    </div>
                </div>
            </section>

            <!-- vertical-map -->
            <div 
                ref="kxd-vertical-map" 
                id="kxd-vertical-map" 
                class="kxd-vertical-map"
            />
        </div>
    </div>
</template>

<script>
/* global $ initialVertical */
import { kxdVerticalLang } from '@/config/kxd_vertical_lang_config.js'
import { get_remote_file_ajax, get_webmap_ajax } from '@/utils/emap/emap_init.js'
import { mapState, mapMutations, mapGetters } from 'vuex'

import { UNITS_CAA } from '@/config/config.js'

import Colorbar from '@kxd_map/component/colorbar.vue'
import QpeTimeLine from '@/components/emap/emap_custom_plugin/qpe_timeline.vue'
import { createLegend, removeLegend, LegendStyle } from '@/utils/useless/legend'
import { lib } from '@/utils/useless/lib'

export default {
    name: 'KxdVerticalMap',

    components: {
        Colorbar,
        QpeTimeLine,
    },

    props: {
        vertical_product: {
            type: Object,
            default() {
                return {}
            },
        },
    },

    data() {
        return {
            control: null,
            name: 'kvmap',
            show_lastest: true,
            legendObj: [],
            renderConfig: [],
            unit: 'm',
            colorbar: null,
            timebar: {
                key: null,
                color: '#fbb03b', //時間軸顏色
                duration: 1000, //時間軸輪播間距
                default_index: null,
                //時間使用 timestamp, 會轉換成 [YYYY/MM/DD(日) hh:mm]格式
                list: [],
                show_play_ctrl: false, //隱藏播放鈕
                play_index: null, //回傳播放頁數
                play_timestamp: null, //回傳時間用以控制顯示產品
                is_playing: false, //回傳播放狀態
            },

            render_vertical_modal: false,
            is_open_path_menu: false,
            path_selected: null,
            default_paths: {},

            processed_vertical_product: {},
            coexist_data_list: [],

            hpa_to_m: 10, //hpa代表高度*hpa_to_m=m, 用來呈現在地形地圖上
        }
    },

    computed: {
        ...mapState(['client_name']),

        ...mapState('emap', ['current_timestamp', 'all_3D_products']),

        ...mapGetters(['api_language_parameters']),

        is_open_vertical_radar: {
            get() {
                return this.$store.state.emap.is_open_vertical_radar
            },
            set(new_value) {
                this.set_is_open_vertical_radar(new_value)
            },
        },

        current_vertical_data_file() {
            const { vertical_data_file } = this.vertical_product
            let coexist_data = []
            if (this.coexist_data_list.length > 0) {
                this.coexist_data_list.forEach((x) => {
                    if (x.timestamp_list.includes(this.current_timestamp)) {
                        coexist_data.push({
                            data_name: x.data_name,
                            data_time_timestamp: this.current_timestamp,
                            file_list: x.vertical_data_file.filter(
                                (v) => v.data_time_timestamp === this.current_timestamp
                            )[0].file_list,
                            height_list: x.vertical_data_file.filter(
                                (v) => v.data_time_timestamp === this.current_timestamp
                            )[0].height_list,
                            pressure_level_list:
                                x.vertical_data_file.filter((v) => v.data_time_timestamp === this.current_timestamp)[0]
                                    .pressure_level_list || [],
                        })
                    }
                })
            }
            return {
                ...vertical_data_file.filter(({ data_time_timestamp }) => {
                    return this.current_timestamp === data_time_timestamp
                })[0],
                coexist_data: coexist_data,
            }
        },

        labelHeight() {
            if (this.vertical_product.data_name == 'id_371') {
                return [0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900].map(
                    (h) => h * this.hpa_to_m
                )
            } else {
                return [0, 1000, 2000, 3000, 4000, 5000, 7000, 9000, 11000, 13000, 15000, 17000]
            }
        },

        labelLeft() {
            if (this.vertical_product.data_name == 'id_371') {
                return [
                    '1000 hPa',
                    '950 hPa',
                    '900 hPa',
                    '850 hPa',
                    '800 hPa',
                    '750 hPa',
                    '700 hPa',
                    '650 hPa',
                    '600 hPa',
                    '550 hPa',
                    '500 hPa',
                    '450 hPa',
                    '400 hPa',
                    '350 hPa',
                    '300 hPa',
                    '250 hPa',
                    '200 hPa',
                    '150 hPa',
                    '100 hPa',
                ]
            } else {
                return this.labelHeight
            }
        },

        lastest_idx() {
            const length = this.vertical_product.vertical_data_file.length
            if (!length) return -1

            return this.show_lastest ? length - 1 : 0
        },

        path_menu_options() {
            return Object.keys(this.default_paths)
        },
    },

    watch: {
        is_open_vertical_radar: {
            immediate: true,
            async handler(new_value) {
                this.control = null // 每次重開剖面地圖視窗都清空上次的資料
                const need_init = new_value && this.control === null
                if (!need_init) return

                if (UNITS_CAA.includes(this.client_name)) {
                    try {
                        const res = await get_remote_file_ajax('/static/map_geojson/Airway3D.json')
                        this.default_paths = res.data
                    } catch (e) {
                        console.error(e)
                    }
                }

                //每次重開剖面地圖視窗都清空 kxd-vertical-map
                document.getElementById('kxd-vertical-map').innerHTML = ''

                this.initial()
            },
        },

        'timebar.play_index': function(idx) {
            this.change(idx)
        },

        path_selected(new_path, old_path) {
            if (old_path) {
                this.control.removeVerticals()
            }
            const paths = this.default_paths[this.path_selected]
            paths.slice(0, paths.length - 1).forEach((path, index, array) => {
                // animation 會把畫面導到剖面上
                const has_animation = array.length === 1 || index === Math.round(array.length / 2)
                const next_path = paths[index + 1]
                this.control.drawVertical({ lnglat: [...path, ...next_path], animate: has_animation, flat: {} })
            })
        },
    },

    methods: {
        ...mapMutations('emap', ['set_is_open_vertical_radar']),

        vertical_product_processing() {
            //取出vertical_data_file資料(未整理高度)
            const { timestamp_list, data_name, vertical_data_file } = this.vertical_product

            if (data_name === 'id_370') {
                // id_370 (WISSDOM風場) 要疊加顯示 id_127 (雷達) 的資料
                // 取出需與 id_370 共同顯示的資料，放入 coexist_data_list
                const id_127_ori_data = this.all_3D_products.find(({ data_name }) => {
                    return data_name === 'id_127'
                })

                this.coexist_data_list = [
                    {
                        data_name: 'id_370',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(0, 3)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_370_sd',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(3, 5)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_370_pixel',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(7, 8)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_370_contour',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(7, 8)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_370_div',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(5, 6)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_370_vor',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(6, 7)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_127',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(6, 7)
                                }),
                            }
                        }),
                        timestamp_list: id_127_ori_data.timestamp_list.filter((t) => timestamp_list.includes(t)),
                        vertical_data_file: id_127_ori_data.vertical_data_file.filter((v) =>
                            timestamp_list.includes(v.data_time_timestamp)
                        ),
                    },
                ]
            } else if (data_name === 'id_371') {
                this.coexist_data_list = [
                    {
                        data_name: 'id_371',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(0, 3)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_371_vor',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(3, 4)
                                }),
                            }
                        }),
                    },
                    {
                        data_name: 'id_371_div',
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file.map((x) => {
                            return {
                                ...x,
                                file_list: x.file_list.map((y) => {
                                    return y.slice(4, 5)
                                }),
                            }
                        }),
                    },
                ]
            } else {
                this.coexist_data_list = [
                    {
                        data_name: data_name,
                        timestamp_list: timestamp_list,
                        vertical_data_file: vertical_data_file,
                    },
                ]
            }

            console.log('[coexist_data_list]', this.coexist_data_list, this.vertical_product)
        },

        initial: function() {
            if (this.control != null) this.control.destroy()

            const { data_name } = this.vertical_product

            this.init()
            this.vertical_product_processing()

            //每個id有一組設定檔, 要先設定過才能顯示
            let data_config_obj = {
                id_127: {
                    name: 'id_127',
                    type: 'pixel',
                    display: '整合回波',
                    autoload: data_name === 'id_127' ? true : false,
                    colorbar: { unit: 'dbz', toFixed: 1, label: [''] },
                },
                id_370: {
                    name: 'id_370',
                    type: 'symbol',
                    symbolType: 'windbar',
                    display: '垂直風',
                    colorbar: {
                        unit: 'm/s',
                        label: ['U', 'V', 'W'],
                        label_unit: ['m/s', 'm/s', '10⁻²m/s'],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    calcW: new Function('u', 'v', 'w', 'return w;'),
                    calcQuantity: new Function('u', 'v', 'w', 'projU', 'projV', 'return Math.sqrt(u * u + v * v);'), //顏色換算成風速
                    colorScale: '255,255,255,0,255,0,0,35,128,0,128,50',
                },
                id_370_sd: {
                    name: 'id_370_sd',
                    type: 'symbol',
                    symbolType: 'windbar',
                    display: '水平風',
                    colorbar: {
                        unit: 'm/s',
                        label: ['ws', 'wd'],
                        label_unit: ['', ''],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    calcU: new Function('spd', 'dir', 'return spd'),
                    calcV: new Function('spd', 'dir', 'return dir'),
                    calcW: new Function('spd', 'dir', 'return 0'),
                    calcProjU: new Function(
                        'u',
                        'v',
                        'w',
                        'projU',
                        'projV',
                        `return u * Math.cos(((-v - 90.0) * Math.PI) / 180.0);`
                    ),
                    calcProjV: new Function(
                        'u',
                        'v',
                        'w',
                        'projU',
                        'projV',
                        `return u * Math.sin(((-v - 90.0) * Math.PI) / 180.0);`
                    ),
                    colorScale: '255,255,255,0,255,0,0,35,128,0,128,50',
                },
                id_370_pixel: {
                    name: 'id_370_pixel',
                    type: 'pixel',
                    display: '整合回波 shading',
                    autoload: false,
                    colorbar: {
                        unit: 'dB',
                        label: [''],
                        label_unit: [''],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    colorScale:
                        '0,255,174,3,0,255,123,5,0,255,76,7,0,255,20,9,25,255,0,11,72,255,0,13,123,255,0,15,178,255,0,17,221,255,0,19,255,238,0,21,255,191,0,24,255,148,0,27,255,97,0,29,255,51,0,36,255,0,0,46,211,5,0,51',
                },
                id_370_contour: {
                    name: 'id_370_contour',
                    type: 'pixel',
                    display: '整合回波 contour',
                    autoload: false,
                    colorbar: {
                        unit: 'dB',
                        label: [''],
                        label_unit: [''],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    colorScale:
                        '0,255,174,3,0,255,123,5,0,255,76,7,0,255,20,9,25,255,0,11,72,255,0,13,123,255,0,15,178,255,0,17,221,255,0,19,255,238,0,21,255,191,0,24,255,148,0,27,255,97,0,29,255,51,0,36,255,0,0,46,211,5,0,51',
                    horDisplayMode: 2,
                    verDisplayMode: 2,
                },
                id_370_div: {
                    name: 'id_370_div',
                    type: 'pixel',
                    display: '輻散場',
                    autoload: false,
                    colorbar: {
                        unit: '10⁻⁵ s⁻¹',
                        label: [''],
                        label_unit: ['10⁻⁵ s⁻¹'],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    colorScale:
                        '0,255,174,3,0,255,123,5,0,255,76,7,0,255,20,9,25,255,0,11,72,255,0,13,123,255,0,15,178,255,0,17,221,255,0,19,255,238,0,21,255,191,0,24,255,148,0,27,255,97,0,29,255,51,0,36,255,0,0,46,211,5,0,51',
                },
                id_370_vor: {
                    name: 'id_370_vor',
                    type: 'pixel',
                    display: '渦度場',
                    autoload: false,
                    colorbar: {
                        unit: '10⁻⁵ s⁻¹',
                        label: [''],
                        label_unit: ['10⁻⁵ s⁻¹'],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    colorScale:
                        '0,255,174,3,0,255,123,5,0,255,76,7,0,255,20,9,25,255,0,11,72,255,0,13,123,255,0,15,178,255,0,17,221,255,0,19,255,238,0,21,255,191,0,24,255,148,0,27,255,97,0,29,255,51,0,36,255,0,0,46,211,5,0,51',
                },
                id_371: {
                    name: 'id_371_uvw',
                    type: 'symbol',
                    symbolType: 'windbar',
                    display: 'RWRF短期預報 uvw',
                    colorbar: {
                        unit: 'm/s',
                        toFixed: 1,
                        label: ['U', 'V', 'W'],
                        label_unit: ['m/s', 'm/s', '10⁻⁶ hPa/s'],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    calcW: new Function('u', 'v', 'w', 'return w;'),
                    calcQuantity: new Function('u', 'v', 'w', 'projU', 'projV', 'return Math.sqrt(u * u + v * v);'), //顏色換算成風速
                    colorScale: '255,255,255,0,255,0,0,35,128,0,128,50',
                },
                id_371_vor: {
                    type: 'pixel',
                    name: 'id_371_vor',
                    display: 'RWRF短期預報 vor',
                    autoload: false,
                    verDisplayMode: 2,
                    colorbar: {
                        unit: '10⁻⁵ s⁻¹',
                        toFixed: 1,
                        label: [''],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    colorScale:
                        '43,153,219,-9999.00,93,173,226,-10.00,133,193,233,-8.00,174,214,241,-6.00,214,234,248,-4.00,235,245,251,-2.00,253,237,236,0.00,250,219,216,2.00,245,183,177,4.00,241,148,138,6.00,236,112,99,8.00,203,67,53,10.0',
                },
                id_371_div: {
                    type: 'pixel',
                    name: 'id_371_div',
                    display: 'RWRF短期預報 div',
                    autoload: false,
                    verDisplayMode: 2,
                    colorbar: {
                        unit: '10⁻⁵ s⁻¹',
                        toFixed: 1,
                        label: [''],
                        val_callback: (val) => {
                            if (val === -9999) return ''
                            return val.toFixed(1)
                        },
                    },
                    colorScale:
                        '43,153,219,-9999.00,93,173,226,-10.00,133,193,233,-8.00,174,214,241,-6.00,214,234,248,-4.00,235,245,251,-2.00,253,237,236,0.00,250,219,216,2.00,245,183,177,4.00,241,148,138,6.00,236,112,99,8.00,203,67,53,10.0',
                },
            }

            this.renderConfig = [] // 要疊加的資料
            const data_to_render_list = [...this.current_vertical_data_file.coexist_data]
            console.log(data_to_render_list)

            data_to_render_list.forEach((x) => {
                let dataRenderConfig = data_config_obj[x.data_name]
                dataRenderConfig.switchList = this.get_switchList(x.data_name, x.height_list, x.pressure_level_list)
                dataRenderConfig.dataList = this.get_dataList(x.data_name)

                this.renderConfig.push(dataRenderConfig)
                console.warn(
                    `${dataRenderConfig.display} : ${dataRenderConfig.type}-${dataRenderConfig.symbolType}`,
                    dataRenderConfig
                )
            })

            this.setData()

            let idx = this.vertical_product.vertical_data_file.length - 1
            this.showDataset(idx)
            // END 初始化剖面物件 ---------------------------------------

            // 開關產品時移除/顯示 colorbar
            $(document).on('click', '.table-item input', function() {
                let id = $(this).val()
                let status = $(this).prop('checked')
                if (status) {
                    $('#' + id).show()
                } else {
                    $('#' + id).hide()
                }
            })
        },

        init() {
            // init() 用於測試重複初始化
            this.control = initialVertical({
                wrapper: '#kxd-vertical-map', // 必填：wrapper: 地圖容器 (需含井字 #id)
                lang: kxdVerticalLang, // 必填：提示訊息、按鈕、說明設定
                viewHeight: 3000, // 選填：viewHeight: 地圖內部高度 (預設 60000)
                heightRatio: 0.022, // 選填：資料轉換地圖內部高度比例 (預設 0.03)
                opacity: 1, // 選填：水平透明度 (預設 1)
                // 舊寫法：會根據資料自動計算
                // 新寫法：各系統自行決定數值帶入
                // 選填：經緯度按鈕、背景按鈕所需設定，會影響控制區按鈕是否顯示
                cube: {
                    range: {
                        // 背景/經緯度 顯示範圍
                        lng: [115, 127],
                        lat: [18, 29],

                        // 背景高度
                        height: [this.labelHeight[0], this.labelHeight[this.labelHeight.length - 1] * 10],
                    },
                    // 背景顏色
                    colors: {
                        left: [255, 0, 0],
                        right: [0, 255, 0],
                        top: [0, 0, 255],
                        bottom: [128, 0, 128],
                    },
                    // 背景/經緯度 欲繪製的線條
                    lines: {
                        // 經度線條
                        lng: [119],
                        lngTexts: ['119E'],

                        // 緯度線條
                        lat: [21],
                        latTexts: ['21N'],

                        // 背景高度線
                        height: [500],
                        heightTexts: ['500m'],
                    },
                },
                // 選填：底圖
                backgroundImage: {
                    path: '/static/common_customized_version/radar_echo_3d/twmap256.jpg',
                    imageProjection: 'EPSG:4326',
                    leftLng: 115.0,
                    rightLng: 127.0,
                    topLat: 29.0,
                    bottomLat: 18.0,
                },
                // 選填：輪廓線
                coastline: ['/static/common_customized_version/radar_echo_3d/county_output.json'],
                // 舊寫法：字串
                // 新寫法：改成物件
                // 選填：地形
                terrain: {
                    path: '/static/map_geojson/dem200m.txt',
                    // autoload 預設 true，若使用 false 須配合 control.setTerrainImage() 使用
                    autoload: false,
                },
                flat: false,
                // 選填：載入第一筆資料，可以先產 colorbar
                loaded: function(eachConfig, name) {
                    console.log(`loaded! ${name}`)
                    // colorbar 資訊必須從資料內取得，因此必須等資料載完
                    let colorbar = eachConfig.colorbar
                    console.log('eachConfig', eachConfig)
                    console.log('colorbar', colorbar)
                    this.createLegendCnv(
                        eachConfig.name,
                        colorbar.unit,
                        colorbar.toFixed,
                        colorbar.label,
                        colorbar.label_unit,
                        colorbar.val_callback
                    )

                    this.set_timebar()
                }.bind(this),

                // 選填：任一個資料(如打點/箭頭)所有高度資料載入完成
                allDataLoaded: (eachConfig, name) => {
                    console.log(`allDataLoaded! ${name}`)
                },
            })

            // 註冊 mousemove 事件，將持續反查之資料數值顯示於 legend
            this.control.canvas.addEventListener('mousemove', (e) => {
                // 反查指定畫布位置上所指向之(最接近)資料
                // 舊寫法：eachConfig.pickData(e.offsetX, e.offsetY)
                // 新寫法：control.pickData(資料名稱, e.offsetX, e.offsetY)，資料名稱帶 null 可取得全部資料
                // 調整說明：帶入資料名稱回傳數值；帶入 null 回傳 {資料名稱: 數值, 資料名稱2: 數值}
                let pickObj = this.control.pickData(null, e.offsetX, e.offsetY)

                for (let name in pickObj) {
                    let legend = this.legendObj[name]
                    let result = pickObj[name]

                    // 將反查結果帶入 legend 物件
                    if (legend) {
                        if (result) {
                            legend.dataChange(result.data, result.colorLv)
                        } else {
                            legend.dataChange([null], -1)
                        }
                    }
                }
            })
        },

        showDataset(idx) {
            // 產生 colorbar 容器
            $('#vertical_display_block').append(
                '<div id="colorbar_area" style="position: absolute; left: 0; top: 0"></div>'
            )

            this.control.showDataset(idx)
        },

        setData() {
            this.control.setData({
                // 寫法：剖面 label 獨立出來，可用 空字串、null 或 undefined，跳格
                label: {
                    // 必填：剖面高度線
                    height: this.labelHeight,

                    // 選填：預設為 height
                    left: this.labelLeft,

                    // 選填：預設為不顯示
                    // right: ['0km', '1km', undefined, '3km', '4km', '5km', '7km', '9km', '11km', '13km', '15km', '17km'],

                    // 選填：label 樣式調整
                    // fontSize: 12,
                    // fontColor: [0, 255, 0],
                    // backgroundColor: [255, 0, 0],
                },

                // 要疊加的資料
                renderConfig: this.renderConfig,
            })
        },

        // 跟一般 colorbar 使用方式一樣，請按照各系統的方式使用
        createLegendCnv(dataName, dataUnit, toFixed, label, label_unit = null, val_callback = null) {
            // 每種資料會有個別設定
            let unit = dataUnit

            const legendStyle = new LegendStyle(unit, function(val) {
                if (val_callback) return val_callback(val)
                return val.toFixed(toFixed)
            })

            // 取得色階資訊
            // 舊寫法：eachConfig.getColors()
            // 新寫法：control.getColors(資料名稱)，資料名稱帶 null 可取得全部資料
            // 調整說明：帶入資料名稱回傳數值；帶入 null 回傳 {資料名稱: 數值, 資料名稱2: 數值}
            const { colors, values } = this.control.getColors(dataName)

            // 將顏色之數值轉換為css之顏色格式
            let colorCodeList = new Array(colors.length / 3)
            for (let ii = 0; ii < colorCodeList.length; ii++) {
                colorCodeList[ii] = `rgb(${colors[ii * 3]},${colors[ii * 3 + 1]},${colors[ii * 3 + 2]})`
            }

            // 刪除重複出現的
            removeLegend(dataName)
            $('#' + dataName).remove()

            // let label = [""]
            // if (id === "symbol" || id === "lidarw" || id === 'uvw') {
            // label = ["U", "V", "W"]
            // }
            let legend = createLegend(
                dataName,
                colorCodeList,
                values,
                label,
                label_unit,
                (idx) => {
                    // 舊寫法：eachConfig.switchColor(idx)
                    // 新寫法：control.switchColor(資料名稱, idx)，資料名稱帶 null 可設定全部資料
                    this.control.switchColor(dataName, idx)
                },
                legendStyle
            )
            this.legendObj[dataName] = legend

            // 將 legend 放至畫面右下角
            document.getElementById('colorbar_area').append(legend)
            legend.setAttribute('id', dataName)
            legend.style.zIndex = 400
        },

        set_timebar() {
            const { timestamp_list } = this.vertical_product
            const has_timebar = this.lastest_idx >= 0
            this.timebar.default_index = this.lastest_idx
            this.timebar.list = has_timebar ? timestamp_list : []
            this.timebar.key = +new Date()
        },
        change(idx) {
            this.control.showDataset(idx)
        },
        draw_vertical(latlngs) {
            // latlngs = [122, 22, 120, 24]
            this.control.drawVertical(latlngs, true)
        },
        draw() {
            $('#draw_line_btn').trigger('click')
        },
        show() {
            $('#show_vertical_btn').trigger('click')
        },
        remove() {
            $('#remove_vertical_btn').trigger('click')
        },
        restore() {
            $('#restore_btn').trigger('click')
        },
        reset() {
            $('#remove_vertical_btn').trigger('click')
            $('#restore_btn').trigger('click')
        },
        toggle_latlng() {
            $('#toggle_latlng_btn').trigger('click')
        },
        toggle_cube() {
            $('#toggle_cube_btn').trigger('click')
        },
        show_helper() {
            $('#show_description_btn').trigger('click')
        },
        toggle_vertical_radar(bool) {
            this.is_open_vertical_radar = bool
        },
        input_get(e) {
            e = e || ''
            e = e.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
            let t = new RegExp('[\\?&]' + e + '=([^&#]*)')
            let n = t.exec(location.search)
            return n === null ? '' : decodeURIComponent(n[1].replace(/\+/g, ' '))
        },

        // switchList 必填：控制高度按鈕，會自動以 height 排序。 *** 如果需要百帕轉換，請自行轉好 ***
        // 舊寫法：renderConfig[n].heightList = [{height: 0, heightText: '0m', show: false, label: true, switch: true}]
        // 新寫法：renderConfig[n].switchList = [{height: 0, heightText: '0m', show: false,              switch: true, viz: 'ground'}]
        // 調整說明：show 該水平資料預設是否顯示，預設 false
        //           switch 是否顯示整列包含開關，預設 true
        //           移除 label 改為 control.setData 設定
        //           新增 viz 產生特殊物件，主要用來繪製地面 (剖面與地面不會連在一起)
        get_switchList(data_name, height_list, pressure_level_list = []) {
            let h_obj = {
                id_127: height_list.map((height, i) => {
                    return {
                        height,
                        heightText: height === 0 ? '地面' : height + this.unit,
                        show: i === 0,
                        switch: true,
                        viz: i === 0 ? 'ground' : '',
                        _heightIndex: i <= 1 ? 0 : i - 1,
                        _showStatus: i === 0 ? 1 : 2,
                    }
                }),
            }

            if (h_obj[data_name]) return h_obj[data_name]

            if (pressure_level_list.length)
                return height_list.map((height, i) => {
                    return {
                        height: height * this.hpa_to_m,
                        heightText: pressure_level_list[i] + 'hPa',
                        show: i === 0,
                        switch: true,
                        _heightIndex: i,
                        _showStatus: i === 0 ? 1 : 2,
                    }
                })

            return height_list.map((height, i) => {
                return {
                    height,
                    heightText: height === 0 ? '地面' : height + this.unit,
                    show: i === 0,
                    switch: true,
                    _heightIndex: i,
                    _showStatus: i === 0 ? 1 : 2,
                }
            })
        },

        // dataList 必填：不同時間點的資料 [{時間1的不同高度資料}, {時間2的不同高度資料}, ...]
        //       或是用 {時間1: {時間1的不同高度資料}, 時間2: {時間2的不同高度資料}, ...}
        //       差別是 control.showDataset(index / 時間1)
        get_dataList(data_name) {
            const selected_data_name = this.vertical_product.data_name
            const { timestamp_list, vertical_data_file } = this.vertical_product
            const coexist_data = this.coexist_data_list.find((o) => o.data_name === data_name)
            let dataList = []

            // RWRF為hpa產品 高度需要換算
            if (selected_data_name === 'id_371') {
                timestamp_list.forEach((timestamp, i) => {
                    let element = {}
                    if (coexist_data.timestamp_list.includes(timestamp)) {
                        let v = coexist_data.vertical_data_file.filter((v) => v.data_time_timestamp === timestamp)[0]
                        v.file_list.forEach((file, i) => {
                            element[v.height_list[i] * this.hpa_to_m] = file.length > 1 ? file : file[0]
                        })
                    }
                    dataList.push(element)
                })
            } else {
                coexist_data.vertical_data_file.forEach((v) => {
                    let element = {}
                    v.file_list.forEach((file, i) => {
                        element[v.height_list[i]] = file
                    })
                    dataList.push(element)
                })
            }

            return dataList
        },
    },
}
</script>

<style>
@import '../../KXD_VUE_MAP/src/packages/KXD-vertical-map/custom_ui.css';
</style>

<style lang="scss">
/* fix menu */
.kxd-vertical-map {
    .switch {
        .slider {
            padding: unset;

            &::before {
                background-color: #eee;
                border: unset;
            }

            &::after {
                content: unset;
            }
        }

        input:checked + .slider {
            background-color: var(--aqua-active);
        }
    }
}

#vertical_display_block {
    // width: 80%;

    position: absolute;
    height: 100%;
    width: calc(100% - 19em);
}

#vertical_control_block {
    height: calc(100% - 3.5rem);

    position: absolute;
    display: flex;
    flex-direction: column;
    // height: 100%;
    width: 19em;
    right: 0;
    padding: 0.6em;
    border-left: 0.063em solid #cacaca;
    box-sizing: border-box;

    .title {
        background: linear-gradient(to right, #334162 0%, #34525f 100%);
        position: relative;
        padding: 5px 10px;
        border: 2px solid gray;
        border-bottom: none;
        border-radius: 5px 5px 0px 0px;
        color: white;
        margin-bottom: 0px;
    }

    .content {
        padding: 10px;
        color: #fff;
        background: var(--base-gray-darken);
    }

    button {
        padding: 0.125rem 0.5rem;
        border: #858585 solid 1px;
    }

    .control_btn {
        min-height: 158px;
        margin-bottom: 5px;
    }

    .data_list {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 1em;
    }

    .data_list .title {
        background: linear-gradient(to right, #334162 0%, #34525f 100%);
        border-bottom: none;
        padding: 5px 10px;
    }

    .data_list .title #product_setting {
        align-self: center;
        padding: 6px;
        margin: 0 2px;
        cursor: pointer;
        font-size: 25px;
    }

    .data_list .title select {
        color: white;
        width: 100%;
    }

    .data_list .title select option {
        color: white;
        background-color: #344960;
        width: 100%;
    }

    .data_list .title > div {
        width: 100%;
        padding: 5px 10px;
        background: #ffffffc7;
        color: black;
    }

    .data_list .title > div:hover {
        box-shadow: 0px 2px 5px 2px #444444;
    }

    .data_list .title > div.active {
        background: gray;
        color: white;
    }

    .data_list .title > div:first-child {
        border-radius: 5px 0px 0px 0px;
    }

    .data_list .title > div:last-child {
        border-radius: 0px 5px 0px 0px;
    }

    .data_list .title span {
        margin-left: 0.5em;
        cursor: pointer;
        border: 1px solid #a5a5a5;
        border-radius: 5px;
        width: 1.5em;
        display: inline-block;
        text-align: center;
    }
}

#product_setting_toggle {
    color: #fff;
    background: var(--base-gray-darken);
    border: 0.126em solid gray;
    border-radius: 0 0 0.3em 0.3em;
    margin-bottom: 10px;
    width: 100%;
    padding: 0.5em 0.5em 1em 0.5em;

    .table-title {
        font-weight: bolder;
        padding: 0em 0.5em 0.5em 0.5em;
    }

    .table-item {
        display: flex;
        justify-content: space-between;
        padding: 0.2em 0.5em;
        gap: 1em;
        border-left: 0.1em solid #ccc;
        border-top: 0.1em solid #ccc;
        border-right: 0.1em solid #ccc;
        align-items: center;
        margin: 0em 0.2em;
        border-radius: 0.3em;
    }

    .table-item:last-child {
        border-bottom: 0.1em solid #ccc;
    }

    .table-item label {
        width: 100%;
        cursor: pointer;
        font-weight: normal;
        padding: 0.2em;
        margin: 0;
    }

    .table-item input {
        cursor: pointer;
    }

    .table-item > div:first-child {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

#data_list_content > div {
    display: none;
}

#data_list_content > div.active {
    display: block;
}

.data_item {
    &:nth-child(odd) {
        background: var(--base-gray-darken) !important;
    }

    &:nth-child(even) {
        background: var(--base-gray) !important;
    }

    &:hover {
        color: #fff;
        background: #2690d0;
    }
}

#show_description_btn {
    border: #fff solid 1px;
    border-radius: 0.25rem;
    font-size: 16px;
}

#description_block {
    th {
        background: linear-gradient(to right, #334162 0%, #34525f 100%) !important;
    }
}

.path-menu {
    &__content {
        &::-webkit-scrollbar {
            width: 0.4em;
        }

        &::-webkit-scrollbar-thumb {
            background: #b1a9a9;
            -ms-border-radius: 5px;
            -moz-border-radius: 5px;
            -webkit-border-radius: 5px;
            border-radius: 5px;
        }
    }

    .v-input__control {
        width: 100%;
    }

    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0;
    }

    .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child),
    .v-radio {
        padding: 0.3em 0.6em;
        margin-bottom: 0;
        border-bottom: 0.12em solid #d8d8d8;
    }

    .v-input--selection-controls.v-input .v-label {
        color: #fff;
    }

    .v-radio {
        margin-right: 0;
    }

    .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }

    .theme--light.v-icon {
        color: #fff;
    }

    .data_item >>> .mdi-radiobox-blank::before {
        /* F43D 中間沒東西 */
        content: '\F43D';
    }

    .data_item >>> .mdi-radiobox-markedd::before {
        /* F43E 中間有東西 */
        content: '\F43E';
    }
}
</style>

<style lang="scss" scoped>
.vertical-radar-profile {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10001;
    background-color: var(--base-dark-blue);
    pointer-events: none;

    &--active {
        pointer-events: auto;
    }
}

/* 地圖容器 */
.kxd-vertical-map-container {
    position: relative;
    width: 100%;
    height: 100%;
    font-size: 1em;
    font-family: '微軟正黑體';
    background-color: rgba(0, 0, 0, 0.4);
    opacity: 0;

    &--active {
        opacity: 1;
    }
}

.vertical-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    width: 100%;
    height: 3.5rem;
    line-height: 50px;
    text-align: center;
    background: var(--linear-gradient-color);

    .vertical-dialog-title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 100%;
    }

    .modal-close {
        margin: 5px;

        &:hover {
            cursor: pointer;
        }
    }
}

.path-menu {
    position: absolute;
    right: 0;
    padding: 0.6em;
    width: 20%;
    height: calc(100% - 3.5rem);
    background: var(--base-dark-blue);
    z-index: 1;
    border-left: 0.063em solid #cacaca;

    &__block {
        height: 90%;
    }

    &__title {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.3em 0.6em;
        font-size: 1.25rem !important;
        font-weight: 500;
        letter-spacing: 0.0125em !important;
        color: #fff;
        background: linear-gradient(to right, #334162 0%, #34525f 100%);
        border-bottom: unset;
        border: 0.126em solid gray;
        border-radius: 0.3em 0.3em 0 0;
    }

    &__content {
        overflow: auto;
        height: 100%;
        background: #e8e8e8;
        border: 0.126em solid gray;
        border-radius: 0 0 0.3em 0.3em;
    }
}

/* 地圖實體 */
.kxd-vertical-map {
    /* height: 100%; */
    height: calc(100vh - 3.5rem);

    /* 地圖底色 */
    background-color: var(--base-dark-blue);
    z-index: 0;
}

/* 地圖物件容器 */
.map-ctrl {
    position: absolute;
    width: 80%;
    height: 100%;

    /*
            地圖容器內元件需使用 .map-top-item 相對上層,
            附件使用
        */
    .map-high-item {
        z-index: 1;
    }
}

/* 地圖右下容器 */
.map-right-bottom-ctrl {
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
}

/* 地圖下方容器 */
.map-bottom-ctrl {
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
}

.vertical-colorbar {
    bottom: 3em;
}

.vertical-timebar {
    width: 100%;
    .map-timebar {
        position: relative;
        width: 90%;
    }
}
</style>
